<template>
  <div class="cross-project-add">
    <div class="top-naview">
      <i class="icon iconfont iconicon_arrow_task_2 activeIconHover " @click="$router.go(-1)"></i>
      <span>创建项目</span>
    </div>
    <div class="content">
      <div class="content-in">
        <div class="met-theme-box">
          <div class="left-box">
            <ColorControl @change="colorChange"></ColorControl>
          </div>
          <el-input class="met-theme" type="textarea" :autosize="{ minRows: 1 }" maxlength="30" placeholder="请在这里输入项目名称" v-model="ruleForm.project_name" resize="none"> </el-input>
        </div>
        <el-card class="content-card" shadow="never">
          <div slot="header" class="clearfix">
            <span>项目基础信息</span>
          </div>
          <div class="met-message-content">
            <el-form :model="ruleForm" :hide-required-asterisk="false" :show-message="false" inline-message size="small" ref="ruleForm" label-position="top" @submit.native.prevent :rules="rules">
              <el-row>
                <el-col :span="8"  class="from-input">
                  <el-form-item label="意向客户" prop="customer_name">
                    <el-input placeholder="请输入客户（公司）名称" maxlength="50" class="professional-box-code" v-model="ruleForm.customer_name" clearable :show-all-levels="false"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8"  class="from-input">
                  <el-form-item label="参与部门" prop="joined_departments" class="cascader-box">
                    <el-cascader :props="props" v-model="joined_departments" clearable @change="changeValue"></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="8"  class="from-input">
                  <el-form-item label="项目骨干" prop="important_members">
                    <SelectCom :selectedData="important_members" v-model="memberVisible" @confirm="selectValue" :options="options"></SelectCom>
                  </el-form-item>
                </el-col>
                <el-col :span="8" class="from-input">
                  <el-form-item label="项目周期" prop="meeting_start_time">
                    <wf-date type="daterange" v-model="arrTime" placeholder="请输入项目开始-结束时间" value-format="yyyy-MM-dd"></wf-date>
                  </el-form-item>
                </el-col>
                <el-col :span="8" class="from-input">
                  <el-form-item label="预计投入" prop="expected_investment">
                    <el-input maxlength="50" v-model="ruleForm.expected_investment" clearable placeholder="请输入"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8" class="from-input">
                  <el-form-item label="预计效益" prop="expected_benefit">
                    <el-input maxlength="50" v-model="ruleForm.expected_benefit" clearable placeholder="请输入"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-card>
        <el-card class="content-card is-required" shadow="never">
          <div slot="header" class="clearfix">
            <span>项目概述</span>
          </div>
          <div class="met-message-content">
            <el-input type="textarea" maxlength="2000" :autosize="{ minRows: 8 }" placeholder="请在这里输入项目概述" v-model="ruleForm.project_overview" resize="none"> </el-input>
          </div>
        </el-card>
        <el-card class="content-card" shadow="never">
          <div slot="header" class="clearfix">
            <span>上传附件</span>
          </div>
          <div class="met-message-content">
            <Upload v-model="fileList"></Upload>
          </div>
        </el-card>
      </div>
    </div>
    <div class="footer">
      <div>
        <wf-button plain style="margin-right: 20px" @click="cancel">取消</wf-button>
        <wf-button @click="uploadData" :loading="loading">提交</wf-button>
      </div>
    </div>
  </div>
</template>
<script>
import Upload from './upload'
import api from '@/services/api/home/home'
import deparApi from "@/services/api/department/department";
import SelectCom from './selectCom'
import { mapMutations } from 'vuex'
import ColorControl from '@/components/colorControl'
export default {
  components: {
    Upload,
    SelectCom,
    ColorControl
  },
  data() {
    return {
      ruleForm: {
        project_name: '',
        customer_name: '',
        expected_benefit: '',
        project_start_time: '',
        project_end_time: '',
        project_overview: '',
        expected_investment: '',
        attachments: [],
        joined_departments: [],
        important_members: [],
        background_color: '',
        background_text: ''
      },
      important_members:[],
      joined_departments: [],
      arrTime: [],
      fileList: [],
      options: [],
      loading: false,
      isFinish: false,
      memberVisible: false,
      rules: {
        customer_name: [{ required: true, message: ' ', trigger: 'change' }],
        joined_departments: [{ required: true, message: ' ', trigger: 'change' }],
        important_members: [{ required: true, message: '', trigger: 'change' }],
        project_overview: [{ required: true, message: ' ', trigger: 'change' }],
      },
      props: {
        lazy: true,
        value: "depart_id",
        label: "name",
        checkStrictly: true,
        multiple: true,
        lazyLoad(node, resolve) {
          const { data } = node;
          deparApi.getDepartmentIndex({ pid: data ? data.depart_id : 0, level: 1 }).then((res) => {
            let tree = (dataset) => {
              dataset.map((item) => {
                if (item.children && item.children.data) {
                  item.children = item.children.data;
                } else {
                  return;
                }
                if (item.children && item.children.length > 0) {
                  tree(item.children);
                }
              });
            };
            tree(res.data);
            res.data.map((res) => {
              res.leaf = !(res.children_amount > 0);
            });
            resolve(res.data);
          });
        },
      },
    }
  },
  beforeRouteLeave(to, from, next) {
    // 退出页面判断是否有更改
    if (this.isFinish || JSON.stringify(this.copyRuleForm) === JSON.stringify(this.ruleForm)) {
      next()
      return
    }
    setTimeout( () => {
       this.$wfAlert('', '确认退出吗？', '退出后不会保存当前编辑内容，请谨慎操作。', '确定').then(() => {
        next()
      }).catch(() => {
        console.log('执行异常')
        next(false)
      })
    }, 100)
  },
  computed: {
    isUploading() {
      return this.fileList.some(res => res.percentage < 100)
    }
  },
  watch: {
    arrTime() {
      if(this.arrTime.length > 0) {
        this.ruleForm.project_start_time = this.arrTime[0]
        this.ruleForm.project_end_time = this.arrTime[1]
      } else {
        this.ruleForm.project_start_time = ''
        this.ruleForm.project_end_time = ''
      }
    },
    fileList: {
      handler() {
        this.ruleForm.attachments = this.fileList.map(res => res.id)
      },
      deep: true
    },
    important_members() {
      this.ruleForm.important_members = this.important_members && this.important_members.length > 0 ? this.important_members.map(res => res.uid) : []
    }
  },
  created() {
    this.copyRuleForm = JSON.parse(JSON.stringify(this.ruleForm))
    this.fetchDepartmentUser()
  },
  methods: {
    ...mapMutations('cross/cross',['SET_ACTIVE']),
    async uploadData() {
      // 提交
      if (this.isUploading) {
        this.$message.warning('正在上传附件，请稍后再提交。')
        return
      }
      this.$refs.ruleForm.validate()
      if (this.reg()) return
      this.loading = true
      try {
        console.log('------------------', this.ruleForm)
        await api.saveCrossProjects(this.ruleForm)
        this.isFinish = true
        this.$message.success('创建项目成功')
        this.SET_ACTIVE('1')
        this.$router.replace('/main/myProject/crossProject')
        // this.$router.go(-1)
      } catch (error) {
      }
      this.loading = false
    },
    cancel() {
      this.$router.go(-1)
    },
    reg() {
      // 表单验证
      if (!this.ruleForm.project_name) {
        this.$message.error(`请输入项目名称`)
        return true
      } else if (!this.ruleForm.customer_name) {
        this.$message.error('请输入客户（公司）名称')
        return true
      } else if (!this.ruleForm.joined_departments || this.ruleForm.joined_departments.length === 0) {
        this.$message.error('请选择参与部门')
        return true
      } else if (!this.ruleForm.important_members || this.ruleForm.important_members.length === 0) {
        this.$message.error('请选择项目骨干')
        return true
      } else if (!this.ruleForm.project_overview) {
        this.$message.error('请输入项目概述')
        return true
      }
      return false
    },
    selectValue(data) {
      this.important_members = data
    },
    changeValue(arr) {
      let dataset= []
      arr.forEach(res => {
        console.log('000-0-00-0-', res, res[res.length - 1])
        dataset.push(res[res.length - 1])
      })
      this.ruleForm.joined_departments = JSON.parse(JSON.stringify(dataset))
    },
    fetchDepartmentUser() {
      // 获取所有的部门员工信息
      deparApi.getDepartmentUser({ working_status: '在职' }).then(res => {
        this.options = res.departmentgroup
      });
    },
    colorChange(value) {
      this.ruleForm.background_color = value.background_color
      this.ruleForm.background_text = value.background_text
    }
  }
}
</script>
<style lang="scss" scoped>
.cross-project-add {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f1f2f3;
  .icon-active--large{
    &:hover {
      color: $color-active;
    }
  }
  .content-in {
    padding-bottom: 60px;
    padding-top: 24px;
    margin: 0 auto;
    width: 1366px;
  }
  .content{
    flex: 1;
    overflow: auto;
  }
  .top-naview {
    height: 54px;
    line-height: 54px;
    font-size: 18px;
    position: relative;
    background-color: #fff;
    i {
      margin-left: 16px;
      font-size: 18px;
      line-height: 1;
      cursor: pointer;
    }
    span {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      font-weight: bold;
    }
  }
  .footer {
    display: flex;
    justify-content: flex-end;
    padding: 0 30px;
    align-items: center;
    height: 54px;
    background-color: #fff;
    border-top: 1px solid rgba(32, 32, 40, 0.08);
    z-index: 99;
  }
  .content-card {
    box-sizing: border-box;
    background-color: #fff;
    margin-top: 20px;
    box-shadow: 0px 4px 12px 0px rgba(214,217,221,0.4);
    border-radius: 6px;
    &.is-required {
      .clearfix >span{
        &:after {
          content: '*';
          color: #F56C6C;
          margin-left: 4px;
        }
      }
    }
    .clearfix {
      display: flex;
      justify-content: space-between;
      font-size: 18px;
      span:nth-child(2) {
        font-size: 14px;
        cursor: pointer;
      }
    }
    /deep/ {
      .el-card {
        border: 0 none;
      }
      .el-card__body {
        padding: 24px;
      }
      .el-card__header {
        border: 0 none;
        padding: 24px;
        padding-bottom: 0;
      }
      .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before,
      .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before {
          display: none;
      }
      .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label::after,
      .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label::after {
          content: '*';
          color: #F56C6C;
          margin-left: 4px;
      }
    }
  }
  .from-input {
    /deep/{
      .el-form-item__content {
        width: 360px;
      }
      .el-input__inner {
        width: 360px;
        height: 40px;
        // background-color: rgba(32, 32, 32, 0.04);
        .el-range-input{
          // background-color: rgba(32, 32, 32, 0.04);
        }
        ::-webkit-input-placeholder{/*Webkit browsers*/
          font-size:14px !important;
        }
      }
      .el-input {
        ::-webkit-input-placeholder{/*Webkit browsers*/
          font-size:14px !important;
        }
      }
      .el-input__clear{
        line-height: 40px !important;
      }
    }
  }
  /deep/{
    .el-textarea__inner {
      background-color: #fff;
      border: 0 none !important;
      border: 0 !important;
      padding: 0 !important;
      &:hover,&:active{
        border: 0 none !important;
      }
    }
    .el-range__icon{
      line-height: 32px;
    }
    .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus {
      border-color: #F56C6C !important;
    }
    .el-input__inner ,.el-textarea__inner{
      font-size: 14px !important;
      ::-webkit-input-placeholder{/*Webkit browsers*/
        font-size:14px !important;
      }
    }
    .el-input,.el-textarea {
      ::-webkit-input-placeholder{/*Webkit browsers*/
        font-size:14px !important;
      }
    }
    .cascader-box {
      .el-cascader__tags {
        display: flex;
        flex-wrap: initial;
        overflow: hidden;
      }
      .el-input__inner{
        height: 40px !important;
      }
    }
  }
  .met-theme-box {
    display: flex;
    align-items: center;
    background-color: #fff;
    box-shadow: 0px 4px 12px 0px rgba(214,217,221,0.4);
    border-radius: 6px;
    .left-box {
      padding: 0 16px;
      border-right: 1px solid rgba(32, 32, 32, 0.16);
      height: 66px;
      display: flex;
      align-items: center;
    }
  }
  .met-theme {
    padding: 10px 0;
    ::-webkit-input-placeholder{/*Webkit browsers*/
      font-size: 18px !important;
    }
    /deep/{
      .el-textarea__inner {
        height: auto;
        min-height: 18px !important;
        font-size: 18px !important;
        border: 0 none !important;
        font-weight: 400;
        padding: 5px 24px !important;

      }
    }
  }
}
</style>
